export const LOCAL_USER_KEY = "LOCAL_USER_KEY";
export const FORM_ORDER_KEY = "FORM_ORDER_KEY";

export const BASE_URL = "http://192.168.0.60:5000/";

